import styled from "styled-components"
import Navbar from "../Components/Navbar"
import Announcements from "../Components/Announcements"
import Newsletter from "../Components/Newsletter"
import Footer from "../Components/Footer"
import AddIcon from '@material-ui/icons/Add';
import RemoveIcon from '@material-ui/icons/Remove';


const Container = styled.div`

`
const Wrapper = styled.div`
    padding: 50px;
    display: flex;
`

const ImageContainer = styled.div`
    flex: 1;
`
const Image = styled.img`
    width: 100%;
    height: 60vh;
    object-fit: cover;
`
const InfoContainer = styled.div`
    flex: 1;
    padding: 0 50px;
`
const Title = styled.h1`
    font-weight: 300;
`
const Description = styled.p`
    font-weight: 200;
    margin: 30px 0;
`
const Pricing = styled.span`
    font-weight: 100;
    font-size: 40px;
    margin: 30px 0;
`
const CalculatePrice = styled.div`
    margin: 30px 0;
    display: flex;
    flex-direction: column;
`
const PriceTag = styled.span`
    font-weight: 200;
`
const AddContainer = styled.div`
    margin: 20px 0;
    display: flex;
    align-items: center;
    justify-content: flex-start;
`
const Amount = styled.span`
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 10px;
    width: 35px;
    height: 25px;
    border-radius: 8px;
    background-color: #bff7bfcc;
`
const Button = styled.button`
    margin-left: 30px;
    border-style: none;
    padding: 5px 10px;
    &:hover {
        background-color: #bff7bfcc;
        transform: scale(1.05);
    }
    cursor: pointer;
    font-weight: 300;
    font-size: 16px;
`

const ServiceInfo = () => {
    return (
        <Container>
            <Navbar />
            <Announcements/>
            <Wrapper >
            <ImageContainer >
                <Image src="https://images.pexels.com/photos/4846097/pexels-photo-4846097.jpeg?cs=srgb&dl=pexels-rachel-claire-4846097.jpg&fm=jpg" />
            </ImageContainer>
            <InfoContainer >
                <Title >
                    Titulo
                </Title>
                <Description >
                    Lorem ipsum dolor sit amet, 
                    consectetur adipisicing elit. Nisi ipsam natus fugiat 
                    minima debitis, laboriosam rerum officia quo in iure?
                </Description>
                <Pricing >
                    $20
                </Pricing>
                <CalculatePrice >
                    <PriceTag >Select amount</PriceTag>
                    <AddContainer >
                        <RemoveIcon />
                        <Amount > 2 </Amount>    
                        <AddIcon />
                        <Button > Add to Cart</Button>
                    </AddContainer>
                </CalculatePrice>
            </InfoContainer>
            </Wrapper>
            <Newsletter />
            <Footer />
        </Container>
    )
}

export default ServiceInfo
